import React, { Fragment, useState } from 'react';
import { Formik, Form, Field } from 'formik';

import SelectFilter from './SelectFilter';

import {
  StyledRoot,
  StyledGap,
  StyledClear,
  StyledClearText,
  StyledClearIcon,
} from './styled';

const DEFAULT_VALUE = 'all';

const Filters = ({ config, onSubmit, onChange }) => {
  const getInitialVals = (initVals = {}) => config.reduce(
    (acc, { name }) => ({
      ...acc,
      [name]: initVals[name] || DEFAULT_VALUE
    }),
    {}
  );

  const [initialVals, updateInitialVals] = useState(getInitialVals());
  const handleSubmit = async (values, actions) => {
    await onSubmit(values);
    updateInitialVals(getInitialVals(values));
    actions.setSubmitting(false);
  };

  return (
    <Formik
      initialValues={initialVals}
      enableReinitialize
      onSubmit={handleSubmit}
      render={({ dirty, values, handleReset }) => (
        <Form>
          <StyledRoot>
            {config.map(({ name, label, options }) => (
              <Field
                key={name}
                name={name}
                render={({ field }) => (
                  <SelectFilter
                    label={label}
                    options={options}
                    {...field}
                    onChange={e => {
                      field.onChange(e);
                      onChange({ ...values, [name]: e.target.value });
                    }}
                  />
                )}
              />
            ))}

            <StyledGap />

            <StyledClear
              tabIndex="-1"
              disabled={!dirty}
              onClick={() => {
                handleReset();
                onChange(getInitialVals());
              }}
            >
              <StyledClearText>Reset filters</StyledClearText>
              <StyledClearIcon />
            </StyledClear>
          </StyledRoot>
        </Form>
      )}
    />
  );
};

export default Filters;
